import './index.scss';
import 'components/select';
import 'utils/ajax_form';
import { errorInterpreter } from 'utils/error_interpreter';
import { handleApiError } from 'utils/api_error_handler';
class QuestionNotebooksTab {
  constructor($context) {
    this.$context = $context;
    this.$createForm = $('.q-create-form', this.$context);
    this.$chooseNotebooksForm = $('.q-choose-notebooks-form', this.$context);
    this.$questionBelt = this.$context.parents('.q-question-belt');
    this.questionId = this.$questionBelt.data('question-id');

    this.bind();
  }

  reload() {
    window.QuestionBelt.loadTab(this.$questionBelt, 'question_notebooks', true);
  }

  createNotebook() {
    const data = $.extend(this.$createForm.serializeObject(), {
      source_project: 1
    });

    if (!data.notebook?.name || data.notebook?.name?.length < 3) {
      return toastr.error('Por favor, informe um nome para o caderno.');
    }

    Thor.Notebook.create(
      {},
      {
        data: data
      }
    )
      .then(result => {
        this.$createForm.clearForm().trigger('ajax:success');

        const { id, name } = result.notebook;

        window.UserTracker.emit('event', {
          eventName: 'notebook created',
          data: {
            id: String(id),
            name
          }
        });

        this.reload();
      })
      .catch(({ response }) => {
        const defaultMessage =
          'Ops! Não foi possível criar o caderno nesse momento!';

        if (response.status === 422) {
          return response.json().then(({ errors }) => {
            const errorMessages = Object.values(errors);
            const message =
              errorMessages.length > 0 ? errorMessages[0][0] : defaultMessage;

            toastr.error(message);
          });
        } else {
          handleApiError(defaultMessage, response);
          this.$createForm.trigger('ajax:error', response);
        }
      });
  }

  chooseNotebooks() {
    const data = this.$chooseNotebooksForm.serializeObject();

    if (!data.notebook_id) {
      toastr.warning(
        'Selecione o caderno para adicionar a questão ou crie um caderno novo.'
      );
      return;
    }

    Thor.NotebookQuestion.create(
      {},
      {
        data: {
          notebook_id: data.notebook_id,
          question_id: this.questionId
        }
      }
    )
      .then(() => {
        this.$chooseNotebooksForm.trigger('ajax:success');
        this.reload();
      })
      .catch(({ response }) => {
        errorInterpreter({
          message:
            'Ops! Não foi possível adicionar a questão ao caderno nesse momento!',
          response
        });
        this.$chooseNotebooksForm.trigger('ajax:error');
      });
  }

  removeNotebook(notebookId, successMessage) {
    Thor.NotebookQuestion.delete(
      {
        id: this.questionId
      },
      {
        data: {
          notebooks_ids: notebookId
        }
      }
    )
      .then(() => {
        toastr.success(successMessage);
        this.reload();
      })
      .catch(({ response }) => {
        handleApiError(
          'Ops! Não foi possível remover o caderno nesse momento!',
          response
        );
      });
  }

  bind() {
    $('.q-select-input', this.$context).qselect();

    this.$createForm
      .ajaxForm()
      .lazyReady()
      .on('submit', e => {
        e.preventDefault();
        this.createNotebook();
        return false;
      });

    this.$chooseNotebooksForm
      .ajaxForm(false, false)
      .lazyReady()
      .on('submit', e => {
        e.preventDefault();
        this.chooseNotebooks();
        return false;
      });

    $('.js-btn-delete', this.$context)
      .off('click')
      .on('click', e => {
        e.preventDefault();
        e.stopPropagation();

        this.removeNotebook(
          $(e.currentTarget).data('notebook-id'),
          $(e.currentTarget).data('success-message')
        );
      });
  }
}

(function ($) {
  'use strict';

  $(document)
    .off('componentLoaded:questions/question_notebooks')
    .on('componentLoaded:questions/question_notebooks', (e, data) => {
      new QuestionNotebooksTab(data.context);
    });
})(jQuery);
